import React from 'react'
import { Button, Card, Row, Col } from 'antd'
import './Footer.scss'

const Footer = props => {
  const { bgColor, copyRights, handlePrivacyPolicy, handleTermsAndServices } = props
  return (
    <div style={{ position: 'relative' }}>
      <Card bordered={false} className="main-card-footer" style={{ background: bgColor }}>
        <Row>
          <Col span={12}>
            <div className="text-left">{copyRights}</div>
          </Col>
          <Col span={12}>
            <div className="text-right">
              <Button type="link" onClick={handlePrivacyPolicy}>
                <div
                  style={{
                    color: '#FFFFFF',
                    textDecoration: 'underline',
                    fontSize: '12px',
                    marginRight: '-12px',
                    marginTop: '-12px',
                  }}
                >
                  Privacy Policy
                </div>
              </Button>
              <div style={{ marginLeft: '7px', marginRight: '7px' }}>|</div>
              <Button type="link" onClick={handleTermsAndServices}>
                <div
                  style={{
                    color: '#FFFFFF',
                    textDecoration: 'underline',
                    fontSize: '12px',
                    marginLeft: '-13px',
                    marginTop: '-12px',
                  }}
                >
                  Terms of Service
                </div>
              </Button>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  )
}
export default Footer
